const loadNewRelicScript = (): void => {
  import(`@/scripts/new-relic/${process.env.NODE_ENV === 'production' ? 'production' : 'staging'}.js`);
};

export default loadNewRelicScript;
